import { CSSProperties, ThemeSpacing } from 'styled-components';

import { WithChildren } from '~/shared/types/WithChildren';

import { Container } from './styles';

interface IFromGroupProps {
  spacing?: ThemeSpacing;
  minWidth?: string;
  style?: CSSProperties;
}

export const FormGroup: WithChildren<IFromGroupProps> = ({
  children,
  minWidth = '200px',
  spacing = 'md',
  style,
}) => {
  return (
    <Container
      style={style}
      spacing={spacing}
      minWidth={minWidth}
      id="form-group"
    >
      {children}
    </Container>
  );
};
